import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

const blog = [
  {
    title: "3D printed glasses evolve with My Very Own Mykita",
    by: "Rob",
    article:
      "If you wear them, you will know that glasses come in surprisingly standard sizes. Unless you've a pinhead or a moon face, you'll probably have never really had to think about how well your specs fit.",
    img: "http://2.bp.blogspot.com/-4PkPJj2EwX0/VhQefR2bDXI/AAAAAAAAFSs/eEmKXm_6DIw/s1600/MYKITA_MVO_05_72dpi.jpg",
    link: "http://www.eye-wear-glasses.com/",
  },
  {
    title: "Marimekko makes its mark on eyewear",
    by: "Rob",
    article:
      "If you wear them, you will know that glasses come in surprisingly standard sizes. Unless you've a pinhead or a moon face, you'll probably have never really had to think about how well your specs fit.",
    img: "http://4.bp.blogspot.com/-5Ck_lc0YKX4/VgrjJWdma7I/AAAAAAAAFQ8/HgaErl7SKao/s1600/marrimeko-eyewear-2015.jpg",
    link: "http://www.eye-wear-glasses.com/",
  },
  {
    title: "James Bond's sunglasses in Spectre",
    by: "Rob",
    article:
      "Mr Bond, we've been expecting you...In the latest James Bond movie, Spectre, Daniel Craig sports the rather wonderfully black and leather Glacier sunglasses by French luxury ski eyewear maker Vuarnet.",
    img: "http://4.bp.blogspot.com/-laaCPCbxgYU/VgrXC6_aGoI/AAAAAAAAFQg/TNgWwJzsqIY/s1600/who-makes-daniel-craigs-sunglasses-in-spectre.jpg",
    link: "http://www.eye-wear-glasses.com/",
  },
];

const Blog = () => {
  return (
    <Container>
      <Typography
        sx={{ color: "#2E3B55", fontWeight: "bold", py: 5 }}
        variant="h5"
      >
        Blogs
      </Typography>
      <Grid container spacing={2}>
        {blog.map((b) => (
          <Grid item xs={12} md={4}>
            <Card sx={{ maxWidth: 345 }}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="200"
                  image={b.img}
                  alt="Sunglass"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    {b.title}
                  </Typography>
                  <Typography variant="body2" color="black">
                    {b.article}
                  </Typography>
                  <Typography
                    gutterBottom
                    variant="h6"
                    color="text.secondary"
                    sx={{ fontSize: 18, py:1 }}
                    component="div"
                  >
                    By: {b.by}
                  </Typography>
                  <Typography
                    textAlign="right"
                    gutterBottom
                    variant="p"
                    component="div"
                    sx={{display:"flex", alignItems:"center", justifyContent:"end"}}
                  >
                    <RemoveRedEyeIcon/><a href={b.link}>See More</a>
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Blog;
